// Regexy nad názvy skupin podkategorií z nativního menu (jazyk shopu) → ikona
// skupiny. PRVNÍ shoda vyhrává, pořadí je nosné (viz menuModel.js).
export default {
  groupIconRules: [
    // Zahrada
    [/řetěz|retez/i, 'chainsaw'],
    [/ruční pil|rucni pil|pilk/i, 'handsaw'],
    [/křovinořez|krovinorez|strunov/i, 'trimmer'],
    [/sekač|sekac|vertikul|provzduš|provzdus|kultiv/i, 'mower'],
    [/zavlaž|zavlaz|postřik|postrik|hadic/i, 'droplets'],
    [/zahradní nářadí|zahradni naradi|rýče|ryce|lopat|motyk/i, 'shovel'],
    [/vrták|vrtak|vrtač|vrtac/i, 'drill'],
    [/květin|kvetin|truhlík|truhlik/i, 'plant'],
    [/kolečk|koleck/i, 'wheelbarrow'],
    [/obrubník|obrubnik|oplocen|plot/i, 'fence'],
    [/bazén|bazen/i, 'waves'],
    [/foliovn|fóliovn/i, 'greenhouse'],
    [/fóli|agrotextil|placht|folie/i, 'layers'],
    [/osvěžovač|osvezovac|desinfek|dezinfek|sprej/i, 'spray'],
    [/pták|ptak/i, 'bird'],
    [/měřič|meric|tester/i, 'gauge'],
    [/lapač|lapac|odpuzovač|odpuzovac|plašič|plasic/i, 'bug'],
    [/domk/i, 'home'],
    [/kompost/i, 'leaf'],
    [/foukač|foukac|vysavač|vysavac/i, 'wind'],
    [/nábytek|nabytek|obývac|obyvac/i, 'armchair'],
    [/hnojiv/i, 'sack'],
    [/čistič|cistic/i, 'broom'],
    // Vánoce (před obecnými pravidly osvětlení/dekorací)
    [/věnc|venc|girland/i, 'wreath'],
    [/ozdob/i, 'bauble'],
    [/dekorac|lešt|lest/i, 'sparkles'],
    // Stavba a dům
    [/topidl|topen/i, 'flame'],
    [/čerpad|cerpad/i, 'droplet'],
    [/úklid|uklid/i, 'broom'],
    [/kabel|prodlužovac|prodluzovac/i, 'plug'],
    [/svář|svar/i, 'welding'],
    [/kompresor/i, 'compressor'],
    [/zvedac|kladkostroj|naviják|navijak/i, 'hook'],
    [/vozík|vozik/i, 'trolley'],
    [/měřid|merid/i, 'ruler'],
    [/organiz|krabič|krabic|šuplí|supli/i, 'drawers'],
    [/řezačk|rezack|lámačk|lamack/i, 'saw-blade'],
    [/malov|barv/i, 'paint-roller'],
    [/žebřík|zebrik|schůdk|schudk/i, 'ladder'],
    // Dílna
    [/aku nářadí|aku naradi/i, 'drill'],
    [/příslušenství k nářadí|prislusenstvi k naradi/i, 'cog'],
    [/regál|regal/i, 'shelf'],
    // Domácnost
    [/kuchyn/i, 'utensils'],
    [/koupeln/i, 'bath'],
    [/kancelář|kancelar/i, 'briefcase'],
    [/camping|kemp|stan/i, 'tent'],
    [/elektronik/i, 'cpu'],
    [/osvětlen|osvetlen|svítid|svitid|světl|svetl|žárov|zarov/i, 'bulb'],
    [/gril/i, 'grill'],
    [/chovatel/i, 'paw'],
    [/sport/i, 'dumbbell'],
    [/botník|botnik/i, 'shoe'],
    [/odpadk/i, 'trash'],
    [/zábav|zabav/i, 'gamepad'],
    [/pro děti|pro deti|hračk|hrack/i, 'gift'],
    [/oblečen|oblecen|oděv|odev/i, 'shirt'],
    [/zámk|zamk/i, 'lock'],
    [/vylepšen|vylepsen/i, 'home'],
    // Dětská hřiště
    [/skluzav/i, 'slide'],
    [/houpač|houpac/i, 'swing'],
    [/odrážed|odrazed|koloběž|kolobez|tříkol|trikol|skateboard/i, 'scooter'],
    [/hřiště|hriste/i, 'seesaw'],
    // Autodoplňky
    [/výbava|vybava/i, 'steering'],
    [/auto-moto|autodopl/i, 'wrench'],
    [/endoskop|kamer/i, 'camera'],
    // Ochranné pomůcky
    [/rukavic/i, 'hand'],
    [/brýle|bryle/i, 'glasses'],
    [/sluchátk|sluchatk/i, 'headset'],
    [/přilb|prilb|helm/i, 'helmet'],
    [/mask|respirát|respirat/i, 'mask'],
    // obecné záchytky (až po specifických)
    [/box/i, 'package'],
    [/aku|akumul|baterie/i, 'battery'],
    [/ochran|bezpeč|bezpec/i, 'shield'],
    [/elektrocentrál|elektrocentral|elektrick|elektro/i, 'bolt'],
    [/nářadí|naradi/i, 'hammer'],
  ],
};
